var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1172 8.41797L11.5817 4.88243L3.97965 12.4844L2.97188 15.779C2.7375 16.5452 3.45442 17.2621 4.22066 17.0277L7.51519 16.02L15.1172 8.41797Z",
    fill: "#769DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6269 5.90925C18.0174 5.51873 18.0174 4.88557 17.6269 4.49504L15.5056 2.37372C15.115 1.9832 14.4819 1.9832 14.0913 2.37372L12.6546 3.81048L16.1901 7.34602L17.6269 5.90925Z",
    fill: "#769DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.248 7.28857L12.7125 3.75304L11.534 4.93155L15.0695 8.46709L16.248 7.28857Z",
    fill: "#BBCEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/Ic_pencil.b00b85c0601b08f276071d888edfb942.svg";
export { ForwardRef as ReactComponent };